// extracted by mini-css-extract-plugin
export var animationBox = "Header-module--animation-box--3bc97";
export var animationBoxInner = "Header-module--animation-box-inner--10dc7";
export var header = "Header-module--header--0f389";